export default "__VITE_ASSET__v4Dx3FlG__"